export const getExpirationDateFromMilliseconds = (ms: number): number => {
  return new Date().getTime() + ms * 1000;
};

export const toUTC = (dt: Date): Date => {
  const tmp = Date.UTC(
    dt.getUTCFullYear(),
    dt.getUTCMonth(),
    dt.getUTCDate(),
    dt.getUTCHours(),
    dt.getUTCMinutes(),
    dt.getUTCSeconds(),
    dt.getUTCMilliseconds()
  );
  // soulf be UTC time
  return new Date(tmp);
};
export const utcNow = (): Date => {
  // new date
  return toUTC(new Date());
};

/**
 * Metodo che converte un'ora locale in UTC
 * @param hour ora locale
 * @param offset offset in ore -> calcolato come -dt.getTimezoneOffset() / 60
 * @returns Ritorna l'ora in UTC
 */
export const hourOffsetToUTC = (hour: number, offset: number): number => {
  return (hour - offset + 24) % 24;
};
